export default "__VITE_ASSET__BKyFWrVY__"